import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Services from "./Pages/Services";
import BlogListing from "./Pages/BlogListing";
import Faq from "./Pages/Faq";
import Error from "./Pages/Error";
import ContactUs from "./Pages/ContactUs";

import ProjectGrid from "./Pages/ProjectGrid";

import ScrollToTop from "./Common/ScrollToTop";
import HVAC from "./Pages/HVAC";
import ElectricalInstrumentation from "./Pages/Electrical&Instrumentation";
import IndoorAirQuality from "./Pages/IndoorAirQuality";
import FPS from "./Pages/FPS";
import BMS from "./Pages/BMS";
import PHE from "./Pages/PHE";

class Components extends React.Component {
  render() {
    return (
      <BrowserRouter basename="/">
        <ScrollToTop />
        <div className="page-wraper">
          <Routes>
            <Route path="/" element={<Home />} />

            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/HVAC" element={<HVAC />} />
            <Route path="/IndoorAirQuality" element={<IndoorAirQuality />} />
            <Route path="/Electrical&Instrumentation" element={<ElectricalInstrumentation />} />
            <Route path="/FPS" element={<FPS />} />
            <Route path="/BMS" element={<BMS />} />
            <Route path="/PHE" element={<PHE />} />

            <Route path="/blog-listing" element={<BlogListing />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/error" element={<Error />} />
            <Route path="/contactus" element={<ContactUs />} />

            <Route path="/project-grid" element={<ProjectGrid />} />

            <Route element={<Error />} />
          </Routes>
        </div>
      </BrowserRouter>
    );
  }
}

export default Components;
